// Planner Task Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import Avatar from '../../common/avatar/avatar.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import PlannerDateRange from '../planner_daterange/planner_daterange.jsx'
import PlannerKanBanItem from '../planner_kanbanitem/planner_kanbanitem.jsx'
import PopoverPlannerHour from '../../popover/popover_planner_hour/popover_planner_hour.jsx'

class PlannerTask extends Component {
  constructor (props) {
    super(props)

    this._references = {
      popoverPlannerHour: React.createRef()
    }
  }

  static get propTypes () {
    return {
      task: PropTypes.object,
      viewMode: PropTypes.string,
      onEdit: PropTypes.func,
      onChangeHour: PropTypes.func,
      isExpand: PropTypes.bool,
      onToggleExpand: PropTypes.func,
      getTaskHours: PropTypes.func,
      showAvailableInfo: PropTypes.bool,
      showPlannedInfo: PropTypes.bool,
      showExpand: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      task: null,
      viewMode: '',
      onEdit: null,
      onChangeHour: null,
      isExpand: false,
      onToggleExpand: null,
      getTaskHours: null,
      showAvailableInfo: false,
      showPlannedInfo: false,
      showExpand: true
    }
  }

  render () {
    const {
      task,
      viewMode,
      onEdit,
      onChangeHour,
      isExpand,
      showAvailableInfo,
      showPlannedInfo,
      showExpand
    } = this.props
    const hasSubtasks = !!(task.subtasks && task.subtasks.length > 0)
    const kanbanInfo = task.kanbanInfo || {}
    const taskDuration = Math.round(task.duration / 60)

    return (
      <div className='planner-task'>
        <div className='taskcont'>
          <div className='titleinfo'>
            <div className='actioncont'>
              {showExpand && hasSubtasks && (
                <IconButton
                  icon={isExpand ? 'arrow-up' : 'arrow-down'}
                  iconSize='12'
                  className='actionexpand'
                  canHover
                  onClick={this._onToggleExpand.bind(this, !isExpand, task.id)}
                />
              )}
            </div>
            <div className='imagecont'>
              <IconButton icon='tasks' size='big' hasBorder canHover />
            </div>
            <div className='titlecont'>
              <div className='title'>{task.title}</div>
              {task.dueDate && (
                <div className='subtitle'>
                  {DateUtil.getDisplayDate(task.dueDate)}
                </div>
              )}
            </div>
            <div className='usercont'>
              {task.user && (
                <div className='userimage'>
                  <Avatar imageUrl={task.user.imageUrl} />
                </div>
              )}
              <div className='userhour'>
                <span
                  className={`info${
                    taskDuration < task.plannedHours ? ' active' : ''
                  }`}
                >
                  {' '}
                  {task.plannedHours || 0}{' '}
                </span>
                <span className='info'> / {taskDuration || 0}</span>
              </div>
            </div>
          </div>
          <div className='dateinfo'>
            {viewMode === 'kanban' ? (
              <>
                <PlannerKanBanItem
                  type='todo'
                  percentage={kanbanInfo.todo || 0}
                />
                <PlannerKanBanItem
                  type='inprogress'
                  percentage={kanbanInfo.inProgress || 0}
                />
                <PlannerKanBanItem
                  type='completed'
                  percentage={kanbanInfo.completed || 0}
                />
              </>
            ) : (
              <PlannerDateRange
                items={task.dayItems}
                canEdit
                showHour
                isWeekMode={viewMode === 'week'}
                onChange={onChangeHour}
                onShowHour={this._onShowHour} // eslint-disable-line react/jsx-handler-names
                showAvailableInfo={showAvailableInfo}
                showPlannedInfo={showPlannedInfo}
                showGanttBar
              />
            )}
          </div>
          <div className='actioninfo'>
            <IconButton
              icon='edit'
              type='secondary'
              canHover
              onClick={onEdit}
            />
          </div>
        </div>
        {hasSubtasks && isExpand && (
          <div className='subtaskcont'>
            {task.subtasks.map((subtask, idx) => (
              <div key={idx} className='planner-subtask'>
                <div className='titleinfo'>
                  <div className='titlewrap'>
                    <div className='imagecont'>
                      <IconButton icon='tasks' iconSize='26' className='logo' />
                    </div>
                    <div className='titlecont'>
                      <div className='title'>{subtask.title}</div>
                    </div>
                  </div>
                </div>
                <div className='dateinfo'>
                  {viewMode === 'kanban' ? (
                    <>
                      <PlannerKanBanItem
                        key='todo'
                        type='todo'
                        percentage={subtask.completed ? 0 : 100}
                        isSubtask
                      />
                      <PlannerKanBanItem
                        key='inprogress'
                        type='inprogress'
                        percentage={0}
                        isSubtask
                      />
                      <PlannerKanBanItem
                        key='completed'
                        type='completed'
                        percentage={subtask.completed ? 100 : 0}
                        isSubtask
                      />
                    </>
                  ) : (
                    <PlannerDateRange
                      items={task.dayItems}
                      canEdit={false}
                      showHour={false}
                      isEmpty
                      isWeekMode={viewMode === 'week'}
                      onChange={onChangeHour}
                    />
                  )}
                </div>
                <div className='actioninfo' />
              </div>
            ))}
          </div>
        )}
        <PopoverPlannerHour
          container={this}
          ref={this._references.popoverPlannerHour}
          showAvailableInfo={showAvailableInfo}
          onChangeHour={onChangeHour}
          onReload={this._onReload} // eslint-disable-line react/jsx-handler-names
        />
      </div>
    )
  }

  _onShowHour = (item, itemIdx) => {
    const { task, getTaskHours } = this.props

    if (this._references.popoverPlannerHour.current && getTaskHours) {
      getTaskHours(task.userId, item.date, null, projects => {
        const dateItemWidth = 32
        window.setTimeout(() => {
          this._references.popoverPlannerHour.current.show(
            projects,
            item,
            itemIdx * dateItemWidth,
            task.projectId,
            task.title
          )
        }, 300)
      })
    }
  }

  _onReload = (date, callback) => {
    const { task, getTaskHours } = this.props
    getTaskHours(task.userId, date, null, callback)
  }

  /* HandlerFunction */

  _onToggleExpand (isExpand, taskId) {
    const { onToggleExpand } = this.props
    if (onToggleExpand) {
      onToggleExpand(isExpand, taskId)
    }
  }
}

export default PlannerTask
